import { render } from "./DecorativoView.vue?vue&type=template&id=7232594f&scoped=true"
import script from "./DecorativoView.vue?vue&type=script&lang=js"
export * from "./DecorativoView.vue?vue&type=script&lang=js"

import "./DecorativoView.vue?vue&type=style&index=0&id=7232594f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7232594f"]])

export default __exports__